<template>
  <ul class="vx-timeline">
    <sidebar-handle-action
      @delete="onDelete"
      @add="onAdd"
      @update="onUpdate"
      ref="popupAddAction"
    />
    <li
      v-for="item in actionsOrdered"
      :key="item.id"
      class="cursor-pointer"
      @click="show(item.id)"
    >
      <div
        class="timeline-icon"
        :class="`bg-${actionStyling[item._type].color}`"
      >
        <feather-icon
          :icon="actionStyling[item._type].icon"
          svgClasses="text-white stroke-current w-5 h-5"
        />
      </div>
      <div class="timeline-info">
        <p class="font-semibold">
          <component v-bind:is="item._type + 'Description'" :action="item" />
        </p>
        <span v-if="item.conditions.length > 0" class="activity-desc">
          <!--<component
            v-for="(condition, idx) in item.conditions"
            :key="idx"
            :idx="idx"
            v-bind:is="condition._type + 'Description'"
            :condition="condition"
        />-->{{ item.conditions.length }} conditions apply</span
        >
      </div>
      <small class="text-grey activity-e-time">{{
        item.delay === 0
          ? "Immediately"
          : "After " + humanizeDuration(item.delay, { largest: 4 })
      }}</small>
    </li>
    <li class="cursor-pointer" v-if="allowNewAction" @click="show(null)">
      <div class="timeline-icon bg-success outline">
        <feather-icon
          icon="PlusIcon"
          svgClasses="text-white stroke-current w-5 h-5"
        />
      </div>
      <div class="timeline-info pt-2">
        <p class="font-semibold">New action</p>
      </div>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from "vuex";
import parse from "parse-duration";
import humanizeDuration from "humanize-duration";
import SidebarHandleAction from "./SidebarHandleAction.vue";
import AddLabelActionDescription from "./AddLabelActionDescription.vue";
import SendMailActionDescription from "./SendMailActionDescription.vue";
import SendSmsActionDescription from "./SendSmsActionDescription.vue";
import AddPointsActionDescription from "./AddPointsActionDescription.vue";
import CreateNightpayVoucherActionDescription from "./CreateNightpayVoucherActionDescription.vue";
import HasReadMailConditionDescription from "./Conditions/HasReadMailConditionDescription.vue";
import HasClickedMailConditionDescription from "./Conditions/HasClickedMailConditionDescription.vue";
import HasLabelConditionDescription from "./Conditions/HasLabelConditionDescription.vue";
import HasConsentConditionDescription from "./Conditions/HasConsentConditionDescription.vue";
import IsDynamicFormConditionDescription from "./Conditions/IsDynamicFormConditionDescription.vue";

export default {
  components: {
    SidebarHandleAction,
    SendMailActionDescription,
    AddLabelActionDescription,
    SendSmsActionDescription,
    HasReadMailConditionDescription,
    AddPointsActionDescription,
    CreateNightpayVoucherActionDescription,
    HasLabelConditionDescription,
    HasClickedMailConditionDescription,
    HasConsentConditionDescription,
    IsDynamicFormConditionDescription,
  },
  name: "action-timeline",
  props: ["automation", "allowNewAction"],
  data() {
    return {
      parse,
      humanizeDuration,
    };
  },
  computed: {
    ...mapGetters({
      actionStyling: "automations/actionStyling",
    }),
    actionsOrdered() {
      return _.orderBy(this.automation.actions, "delay");
    },
  },
  methods: {
    createNewAction() {
      return {
        id: this.uuidv4(),
        _type: "SendMailAction",
        delay: 0,
        conditions: [],
      };
    },
    show(id) {
      if (!id) {
        this.$refs.popupAddAction.show(this.createNewAction(), true);
      } else {
        const editAction = JSON.parse(
          JSON.stringify(this.automation.actions.find((a) => a.id === id))
        );
        this.$refs.popupAddAction.show(editAction, false);
      }
    },
    onDelete(id) {
      this.automation.actions = this.automation.actions.filter(
        (action) => action.id !== id
      );
      console.log("Delete", id);
    },
    onAdd(action) {
      this.automation.actions.push(action);
      console.log("add", action);
    },
    onUpdate(action) {
      this.automation.actions = this.automation.actions.map((a) =>
        a.id === action.id ? action : a
      );
      console.log("update", action);
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
